import { ReactElement, ReactNode } from 'react'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

interface Props extends LoadingButtonProps {
  children: ReactElement | string | ReactNode
}

const MagicButton = ({ children, ...props }: Props): ReactElement => (
  <LoadingButton variant="outlined" {...props} startIcon={<AutoFixHighIcon />}>
    {children}
  </LoadingButton>
)

export default MagicButton
